import type { AllActions } from "../../reducers/actions";
import { AllActionsEnum } from "../../reducers/actions";
import { citizenApi } from "../../services/citizen-api-instance";
import { awaitPendingQuestionnairePersistence } from "../../stores/questionnaire/questionnaire-persistence-tracker";

export async function retrieveQuestionnaire(setRootStore: (action: AllActions) => void) {
  try {
    await awaitPendingQuestionnairePersistence();
    const {
      data: { questionnaire },
    } = await citizenApi.getQuestionnaireFields();

    setRootStore({ type: AllActionsEnum.UPDATE_QUESTIONNAIRE, payload: { questionnaire, notify: true } });
  } catch (error: unknown) {
    console.error("FAILED TO LOAD CITIZEN QUESTIONNAIRE", error);
  }
}
